<template>

    <div class="order">
        <changes
            v-if="changes"
            :changes="changes"
        ></changes>

        <h2>{{ lang('all.bestelling', {'%number%': order.data.number}) }}</h2>

        <confirmation-table
            :order="order"
        ></confirmation-table>

        <div class="text-right">
            <button
                v-tooltip="lang('all.de_bestelde_producten_opnieuw_in_de_winkelwagen_plaatsen')"
                class="btn btn-primary"
                @click="addOrderedProductsToCart"
                :disabled="reordering"
            >{{ lang('all.opnieuw_bestellen') }}</button>
        </div>

        <h3 class="mt-4">{{ lang('all.bestelde_producten') }}</h3>
        <table class="table table-striped">
            <thead>
                <tr>
                    <th colspan="2">{{ lang('all.product') }}</th>
                    <th class="text-right">{{ lang('all.prijs') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="products.length === 0">
                    <td colspan="5">Er zijn geen producten gevonden... Neem s.v.p. contact met ons op om dit te controleren</td>
                </tr>
                <tr
                    v-for="product in products"
                >
                    <td>
                        <img
                            :src="product.product.image.url"
                            :alt="product.product.image.name"
                            style="max-width:100px;"
                        />
                    </td>
                    <td>
                        <h4>
                            <inertia-link
                                v-if="product.product.code !== necktag && product.product.slug !== null"
                                :href="route('products.item', {brand_slug: product.product.brand_slug, slug: product.product.slug})"
                            >
                                {{ product.product.name }}
                            </inertia-link>
                            <span v-else>{{ product.product.name }}</span>
                        </h4>
                        <p>
                            <strong>{{ lang('all.aantal') }}:</strong> {{ product.quantity }}<br>
                            <strong>SKU/EAN:</strong> {{ product.product.code }}
                        </p>
                    </td>
                    <td class="text-right">
                        {{ (product.price * product.quantity) | toCurrency }}
                    </td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                    <td>{{ lang('all.betaalwijze') }}: {{ order.data.paymentmethod.name }}</td>
                    <td class="text-right">{{ order.data.paymentmethod.price | toCurrency }}</td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                    <td>{{ lang('all.verzendwijze') }}: {{ order.data.shippingmethod.name }}</td>
                    <td class="text-right">{{ order.data.shippingmethod.price | toCurrency }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="text-right" colspan="2">{{ lang('all.subtotaal2') }}</td>
                    <td class="text-right">{{ order.data.totals.subtotal | toCurrency }}</td>
                </tr>
                <tr>
                    <td class="text-right" colspan="2">{{ lang('all.btw2') }}</td>
                    <td class="text-right">{{ order.data.totals.taxes | toCurrency }}</td>
                </tr>
                <tr>
                    <td class="text-right" colspan="2">{{ lang('all.totaal') }}</td>
                    <td class="text-right">{{ order.data.totals.total | toCurrency }}</td>
                </tr>
            </tfoot>
        </table>

        <div class="row mt-4">
            <div class="col-6">
                <h3>{{ lang('all.factuuradres') }}</h3>
                <address>
                    <span v-html="formatAddr(order.data.billing_address)"></span>
                </address>
            </div>
            <div class="col-6">
                <h3>{{ lang('all.verzendadres') }}</h3>
                <address>
                    <span v-html="formatAddr(order.data.shipping_address)"></span>
                </address>
            </div>
        </div>
    </div>

</template>

<script>

import MyAccountLayout from "../../../../Shared/Auth/MyAccount/Layout";
import ConfirmationTable from "../../../../components/Orders/ConfirmationTable";
import FormatAddress from "../../../../Libraries/FormatAddress";
import Changes from '../../../../components/Cart/Changes';
import {mapActions} from "vuex";

export default {

    components: {
        ConfirmationTable,
        Changes,
    },

    data() {
        return {
            reordering: false,
        }
    },

    layout:MyAccountLayout,

    metaInfo: {
        title: 'Mijn bestellingen'
    },

    methods: {
        ...mapActions([
            'fetchCart',
        ]),

        addOrderedProductsToCart() {
            if (this.reordering === true) {
                return;
            }

            this.reordering = true;
            this.$inertia.post(this.route('auth.myaccount.orders.reorder', {uuid: this.order.data.uuid}), {}, {
                onFinish: () => {
                    this.reordering = false;
                    this.fetchCart();
                },
            });
        },

        formatAddr(address) {
            return FormatAddress(address);
        },
    },

    name:'AuthMyAccountOrdersShow',

    props: {
        changes:{
            type:Object,
            default:() => {},
        },
        necktag: {
            required:true,
            type:String,
        },
        order: {
            required:true,
            type:Object,
        },
        products: {
            required:true,
        },
    },

}

</script>
